import { render } from "./DashSection.vue?vue&type=template&id=0eb0a11a"
import script from "./DashSection.vue?vue&type=script&lang=js"
export * from "./DashSection.vue?vue&type=script&lang=js"
script.render = render

export default script